module.exports = __webpack_public_path__ + "bi.svg?12a40d8db0b02233e8bdfe888231bfdb";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/bi.svg
// module id = 1001
// module chunks = 0